import { Autocomplete, TextField } from "@mui/material";
import { useEffect } from "react";
import useStateData from "../../Queries/stateDataQuery";
import { useBoundStore } from "useStore";

export default function StatusFilter({ countryId }) {
  const stateDataQuery = useStateData({ countryId: countryId });
  const statusData = stateDataQuery.data ?? [];
  const selectedStatus = useBoundStore((state) => state.soAdminSelectedStatus);
  const setSelectedStatus = useBoundStore(
    (state) => state.setSoAdminSelectedStatus,
  );

  const handleStatusChange = (event, newValue) => {
    if (newValue === null) {
      const defaultStatus = stateDataQuery.data?.find((s) => s.id === 1);
      setSelectedStatus(defaultStatus);
    } else {
      setSelectedStatus(newValue);
    }
  };
  return (
    <Autocomplete
      //   disabled={isLoading}
      id="combo-box-demo"
      options={statusData}
      getOptionLabel={(option) => option.nombre_estado}
      sx={{
        width: 300,
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#fff",
          borderRadius: "8px",
        },
        "& .MuiInputBase-input": {
          backgroundColor: "#fff !important",
          borderRadius: "8px",
          WebkitBoxShadow: "0 0 0 1000px white inset",
        },
      }}
      onChange={handleStatusChange}
      renderInput={(params) => <TextField {...params} label="Estados" />}
      value={selectedStatus}
    />
  );
}
